import styled, { css } from "styled-components";

/* -------- Estilização ---------- */

import { Container, ListItemAvatar } from "@material-ui/core";
import { ListItemText, Button, Typography } from "@material-ui/core";
import TimelineDot from "@material-ui/lab/TimelineDot";

const primary = (props) => props.theme.palette.primary;
const secondary = (props) => props.theme.palette.secondary;
const lightgreen = (props) => props.theme.palette.lightgreen;
const lightgrey = (props) => props.theme.palette.lightgrey;
const blue = (props) => props.theme.palette.blue;
const grey = (props) => props.theme.palette.grey;

const mulish = (props) => props.theme.fonts.mulish;
const opensans = (props) => props.theme.fonts.opensans;
const montserrat = (props) => props.theme.fonts.montserrat;

export const Header = styled.div`
  width: 100%;
`;
export const Body = styled.div`
  width: 100%;
`;

export const Padding = styled.div`
  padding: ${(props) => props.padding}px;
`;

export const MinHeight = styled.div`
  min-height: ${(props) => props.minHeight * 10}px;
`;

export const SubtitleContainer = styled.div``;

export const ColorExample = styled.div`
  border: 1px solid #00000050;
  border-radius: 3px;
  background: #ffcfc7;
  height: 15px;
  width: 15px;
  margin-right: 10px;
  float: left;
`;

export const Subtitle = styled.span`
  font-family: ${opensans};
  font-size: 0.8rem;
`;

export const Margin = styled.div`
  ${(props) =>
    props.margin &&
    css`
      margin-top: ${(props) => props.margin.replace(/( )+/g, "px ")}px;
    `};

  ${(props) =>
    props.top &&
    css`
      margin-top: ${(props) => props.top}px;
    `};

  ${(props) =>
    props.left &&
    css`
      margin-left: ${(props) => props.left}px;
    `};

  ${(props) =>
    props.bottom &&
    css`
      margin-bottom: ${(props) => props.bottom}px;
    `};

  ${(props) =>
    props.right &&
    css`
      margin-right: ${(props) => props.right}px;
    `};
`;

export const HeaderEmissao = styled.div`
  header {
    .MuiGrid-root {
      justify-content: center;
      align-items: center;
    }
  }
`;

export const Center = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
  width: 100%;
`;

export const NotaContainer = styled(Container)`
  margin-top: 80px;
  padding: 20px;

  Button {
    span {
      font-family: ${opensans};
      font-size: 0.675rem;
    }
    height: 100%;
  }

  Table {
    margin-top: 10px;
    Thead {
      background-color: ${secondary};
      box-shadow: 3px 3px 3px ${(props) => props.theme.palette.darkgrey};
      tr {
        .Mui-checked {
          color: ${primary};
        }
        th {
          span {
            font-family: ${opensans}, sans-serif !important;
          }
        }
      }
    }
    Tbody {
      td {
        font-family: ${opensans}, sans-serif !important;
        .Mui-checked {
          color: ${primary};
        }
      }
      .Mui-selected {
        background-color: ${lightgreen};
        &:hover {
          background-color: ${lightgreen};
        }
        border: none;
      }
    }
  }

  .MuiGrid-root {
    min-width: unset;
    .MuiTableCell-sizeSmall {
      padding: 6px 8px 6px 8px;
    }
  }

  .MuiChip-root {
    margin: 0;
    span {
      font-weight: bolder;
      font-family: ${mulish};
    }
  }

  .MuiIcon-root {
    font-family: "Material Icons" !important;
  }

  .MuiFormControl-root {
    width: 100%;

    label {
      font-family: ${opensans} !important;
    }

    input {
      font-family: ${opensans} !important;
    }
  }

  .MuiAccordionSummary-content {
    legend {
      width: 100%;
    }
  }
`;

export const StatusControl = styled.div`
  .MuiChip-root {
    padding: 20px;
    width: 100%;
    span {
      font-size: 1.2rem;
    }
  }
`;

export const Cabecalho = styled.div`
  margin-top: 20px;

  .MuiContainer-root {
    padding: 0px;
    margin: 0;
  }

  label {
    font-family: ${opensans};
  }

  .MuiContainer-maxWidthXl {
    margin-bottom: 20px;
  }

  ${Body} {
    .MuiGrid-container {
      margin-bottom: 10px;
    }
  }
`;

export const Remetente = styled.div`
  margin-top: 20px;

  .MuiContainer-root {
    padding: 0px;
    margin: 0;
  }

  .MuiChip-root {
    padding: 20px;
    width: 100%;
    span {
      font-size: 1.2rem;
    }
  }

  ${Body} {
    padding: 0;

    .MuiChip-root {
      padding-left: 10px;
      padding-right: 10px;
      span {
        font-size: 0.925rem;
      }
    }

    .MuiAccordion-root {
      margin-bottom: 15px !important;

      .MuiCollapse-wrapper {
        margin-bottom: 10px;
      }
    }
  }
`;

export const Itens = styled.div`
  margin-top: 20px;

  ${Header} {
    Button {
      width: 100%;
    }
  }

  .MuiChip-root {
    padding: 20px;
    width: 100%;
    span {
      font-size: 1.2rem;
    }
  }

  ${Body} {
    margin-bottom: 20px;

    .MuiChip-root {
      padding: 10px;

      .MuiChip-label {
        font-size: 0.975rem;
      }
    }
  }
`;

export const BodyItens = styled.div`
  .MuiAccordionDetails-root {
    display: block;
  }
`;

export const FormaPagto = styled.div``;
export const Transportadora = styled.div``;
export const Documentos = styled.div``;
export const Importacao = styled.div``;
export const Exportacao = styled.div``;
export const AutorizadosXml = styled.div``;

export const Secundarios = styled.div`
  margin-top: 20px;

  ${Header} {
    .MuiChip-root {
      padding: 20px;
      width: 100%;
      span {
        font-size: 1.2rem;
      }
    }
  }

  ${FormaPagto} {
    .MuiChip-root {
      padding: 10px;

      .MuiChip-label {
        font-size: 0.975rem;
      }
    }

    .MuiButton-contained {
      width: 100%;
    }
  }

  ${Transportadora} {
    .MuiChip-root {
      padding: 10px;

      .MuiChip-label {
        font-size: 0.975rem;
      }
    }
    ${Header} {
      .MuiButton-contained {
        width: 100%;
      }
    }
  }

  ${Documentos} {
    ${Header} {
      .MuiButton-contained {
        width: 100%;
      }
    }
  }

  ${Importacao} {
    .MuiChip-root {
      padding: 10px;
      width: 100%;

      .MuiChip-label {
        font-size: 0.975rem;
      }
    }

    ${Header} {
      Button {
        width: 100%;
      }
    }

    ${Body} {
      Fieldset {
        margin-top: 20px;
      }
    }
  }
`;

export const DialogProduto = styled.div`
  .MuiFormControl-root {
    width: 100%;

    label {
      font-family: ${opensans} !important;
    }

    input {
      font-family: ${opensans} !important;
    }
  }

  .MuiContainer-maxWidthXl {
    overflow-y: hidden;
  }

  legend {
    width: 100%;
  }

  header {
    .MuiTypography-root {
      font-family: ${opensans}, sans-serif;
      margin-left: 20px;
    }

    .MuiIcon-root {
      font-family: "Material Icons" !important;
    }

    .MuiIconButton-root {
      &:hover {
        background-color: ${secondary} !important;
        color: black;
      }
    }

    .MuiButton-contained {
      width: 100%;
      height: 100%;
      span {
        font-family: ${opensans};
      }
    }
  }

  ${Body} {
    margin-top: 70px;

    .MuiIcon-root {
      font-family: "Material Icons" !important;
    }

    .MuiButton-contained {
      width: 100%;
      height: 100%;
      span {
        font-family: ${opensans};
      }
    }

    .MuiChip-root {
      margin: 0;
      padding: 10px;
      width: 100%;

      .MuiChip-label {
        font-family: ${opensans}, sans-serif;
        font-size: 0.975rem;
      }
    }
  }
`;

export const HeaderModal = styled.div`
  .MuiDialogTitle-root {
    padding: 0px;
    .MuiTypography-h6 {
      line-height: unset;
    }
  }

  .MuiChip-root {
    margin: 0;
    padding: 10px;
    border-radius: 0px;
    width: 100%;

    .MuiGrid-root {
      display: flex;
      justify-content: center;
      align-items: center;

      svg {
        cursor: pointer;
      }
    }

    .MuiChip-label {
      width: 100%;
      align-items: center;
      justify-content: center;
      display: flex !important;
      font-family: ${montserrat}, sans-serif;
      font-size: 0.975rem;
    }
  }
`;

export const MainActions = styled.div`
  margin-top: 20px;
  .MuiButton-contained {
    width: 100%;
    height: 100%;
    span {
      font-size: 1rem;
      font-family: ${opensans};
    }
  }
`;

export const ListAvatar = styled(ListItemAvatar)``;
export const TextList = styled(ListItemText)`
  text-align: left;
`;
export const ButtonList = styled(Button)``;

export const ModalAutomatica = styled.div`
  .MuiAvatar-root {
    background-color: ${primary};
    color: ${secondary};
  }

  ${TextList} {
    span {
      font-family: ${montserrat}, sans-serif !important;
      font-weight: bolder;
    }
  }
  ${ButtonList} {
    width: 100%;
    background-color: ${secondary};
    border-radius: 1rem;
    padding: 15px;
    &:hover {
      background-color: ${lightgreen};
    }
  }
`;

export const StyledTable = styled.div`
  ${Body} {
    .MuiPaper-root {
      margin-bottom: 20px;
    }
    Table {
      margin-top: 5px;
      Thead {
        background-color: ${secondary};
        box-shadow: 3px 3px 3px ${(props) => props.theme.palette.darkgrey};
        tr {
          .Mui-checked {
            color: ${primary};
          }
          th {
            span {
              font-family: ${opensans}, sans-serif !important;
            }
          }
        }
      }
      Tbody {
        max-height: 180px;
        td {
          font-family: ${opensans}, sans-serif !important;
          .Mui-checked {
            color: ${primary};
          }
        }
        .Mui-selected {
          background-color: ${lightgreen};
          &:hover {
            background-color: ${lightgreen};
          }
          border: none;
        }
      }
    }
  }
`;

export const WizardVenda = styled(StyledTable)`
  .MuiAvatar-root {
    background-color: ${primary};
  }
  .MuiTypography-root {
    font-family: ${opensans};
  }
  margin-bottom: 10px;

  .MuiTableBody-root {
    max-height: 140px !important;
  }
`;

export const ModalCancelamento = styled.div`
  ${Body} {
    padding-top: 20px;
    padding-bottom: 20px;
  }
`;

export const Text = styled(Typography)``;
export const TimelineIcon = styled(TimelineDot)``;
export const ModalCartaCorrecaoNF = styled(ModalCancelamento)`
  ${Text} {
    font-family: ${opensans};
  }
  ${TimelineIcon} {
    background-color: ${lightgreen};
  }
`;

export const FontButton = styled.div`
  width: 100%;
  Button {
    span {
      margin: 2.5px;
      font-family: ${opensans};
      font-size: 0.875rem;
    }
    height: 100%;
    .MuiIcon-root {
      font-family: "Material Icons" !important;
    }
  }
`;

export const CardFinancial = styled.div``;
export const WizardFooter = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
  width: 100%;
  justify-content: center;

  li {
    width: unset;
  }
`;

export const WizardFinancial = styled.div`
  width: 100%;
  .MuiChip-root {
    margin: 0;
    width: 100%;
    span {
      font-family: ${opensans};
      font-size: 1.2rem;
    }
  }

  .MuiCardContent-root {
    min-height: 100px;
    max-height: 100px;
  }

  ${CardFinancial} {
    background-color: ${secondary};
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;

    .MuiSvgIcon-root {
      font-size: 5rem;
      color: ${blue};
    }
  }
`;

export const CloseAtRight = styled.div`
  .MuiButton-root {
    border-radius: 0 4px 0 0;
  }

  .MuiButton-startIcon {
    margin: 0;
  }
`;

export const DivisorLabel = styled(Typography)`
  width: 100%;
  margin: 8px !important;
  font-weight: bold !important;
  color: ${grey};
`;

export const Divisor = styled.div`
  margin: 16px 8px;
  display: block;
  width: 100%;
  border-bottom: 1px solid ${lightgrey};
`;
